export const environment = {
    production: false,
    authorizationServerUrl: 'https://ib-stage-accounts.celloscope.net',
    resourceServerUrl: 'https://ib-stage.celloscope.net/resource-api'
};
